import statistic from './statistic'

export default {
  settings: {
    hasOvertime: true,
    hasShootouts: true,
    hasDelayedEvents: true,
    needToStopTimerOnPeriodDurationEnd: true
  },
  actionTypes: {
    numberOfPlayersChangeEvents: [
      'RED_CARD',
      'YELLOW_CARD',
      'PLAYER_ON_PITCH'
    ],
    score: ['GOAL', 'DROP_GOAL', 'TRY', 'PENALTY_TRY', 'CONVERSION', 'CONVERSION_GOAL']
  },
  modules: {
    info: [
      {
        type: 'timer',
        component: 'rugby-timer'
      },
      {
        type: 'players',
        props: {
          home: ingameData => ingameData.playersCount.home,
          away: ingameData => ingameData.playersCount.away
        }
      },
      {
        type: 'periods',
        props: {
          className: 'liveCardPeriods__slider_left'
        }
      }
    ],
    score: {
      component: 'score-component',
      score: ingameData => ingameData.score,
      tackles: ingameData => ingameData.tackles
    },
    fieldScheme: {
      component: 'rugby-field'
    },
    statistic,
    eventLog: true
  },
  storeScheme: {
    score: {
      home: 0,
      away: 0
    },
    tackles: {
      home: null,
      away: null
    },
    playersCount: {
      home: 7,
      away: 7
    },
    shootoutsLog: {
      home: [],
      away: []
    },
    getOvertimePeriodName: () => 'ОТ',
    zone: 4,
    leftSideTeam: 1,
    shootoutPeriodName: 'SO',
  }
}
